































import {Component,Prop, Vue} from 'nuxt-property-decorator';

import MPrice from '@/components/module/MPrice.vue';

@Component({
    components: {
	    MPrice
    }
})
export default class MCoupon extends Vue {
	
}
